import signOutAlt from './rightFromBracket';

export const faSignOutAlt = signOutAlt('classic', 'thin');
export const falSignOutAlt = signOutAlt('classic', 'light');
export const fatSignOutAlt = signOutAlt('classic', 'thin');
export const fadSignOutAlt = signOutAlt('duotone', 'thin');
export const fasSignOutAlt = signOutAlt('classic', 'solid');
export const farSignOutAlt = signOutAlt('classic', 'regular');

export default signOutAlt;
